// SVGs shamelessy taken from Adyen, e.g.
// https://checkoutshopper-test.cdn.adyen.com/checkoutshopper/images/logos/card.svg

export const AdyenGooglePay = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="26"
    fill="none"
    viewBox="0 0 40 26"
  >
    <path
      fill="#fff"
      d="M29.13 2.41H10.87C5.17 2.41.5 7.18.5 13.01a10.5 10.5 0 0 0 10.37 10.58h18.26c5.7 0 10.37-4.76 10.37-10.59 0-5.82-4.67-10.59-10.37-10.59Z"
    />
    <path
      fill="#3C4043"
      d="M29.13 3.27c1.28 0 2.52.26 3.7.77a9.6 9.6 0 0 1 5.08 5.19 9.78 9.78 0 0 1 0 7.55 9.83 9.83 0 0 1-5.08 5.18 9.26 9.26 0 0 1-3.7.77H10.87a9.24 9.24 0 0 1-3.7-.77 9.6 9.6 0 0 1-5.08-5.18 9.78 9.78 0 0 1 0-7.55 9.83 9.83 0 0 1 5.08-5.19 9.24 9.24 0 0 1 3.7-.77h18.26Zm0-.86H10.87C5.17 2.41.5 7.18.5 13.01a10.5 10.5 0 0 0 10.37 10.58h18.26c5.7 0 10.37-4.76 10.37-10.59 0-5.82-4.67-10.59-10.37-10.59Z"
    />
    <path
      fill="#3C4043"
      d="M19.1 13.75v3.2h-1v-7.9h2.64c.67 0 1.24.23 1.7.68.49.46.72 1.01.72 1.67a2.2 2.2 0 0 1-.71 1.68c-.46.45-1.03.67-1.7.67H19.1Zm0-3.73v2.76h1.66c.4 0 .73-.14.99-.4.26-.28.4-.6.4-.98 0-.36-.14-.68-.4-.95a1.28 1.28 0 0 0-.99-.42H19.1Zm6.67 1.35c.73 0 1.31.2 1.74.6.42.4.64.95.64 1.65v3.34h-.95v-.76h-.04a1.9 1.9 0 0 1-1.65.93 2.1 2.1 0 0 1-1.46-.53c-.4-.35-.6-.8-.6-1.32 0-.56.21-1 .63-1.34.41-.33.97-.5 1.66-.5.59 0 1.07.12 1.45.34v-.23c0-.36-.13-.65-.4-.9a1.4 1.4 0 0 0-.97-.37c-.56 0-1 .24-1.32.72l-.88-.56a2.42 2.42 0 0 1 2.15-1.07Zm-1.29 3.92c0 .27.11.5.33.67.22.17.48.26.78.26.42 0 .79-.16 1.12-.48.32-.31.49-.68.49-1.11a2.02 2.02 0 0 0-1.3-.38c-.4 0-.74.1-1.01.3a.9.9 0 0 0-.4.74Zm9.08-3.75-3.32 7.8h-1.02l1.23-2.73-2.19-5.07h1.09l1.57 3.89h.02l1.54-3.89h1.08Z"
    />
    <path
      fill="#4285F4"
      d="M15.14 13.1c0-.32-.03-.64-.09-.95h-4.17v1.75h2.4a2.1 2.1 0 0 1-.89 1.4v1.14h1.43a4.49 4.49 0 0 0 1.32-3.33Z"
    />
    <path
      fill="#34A853"
      d="M12.4 15.3a2.66 2.66 0 0 1-4-1.44H6.9v1.18a4.43 4.43 0 0 0 6.91 1.4l-1.43-1.13Z"
    />
    <path
      fill="#FABB05"
      d="M8.25 13c0-.3.05-.59.14-.86v-1.17H6.9a4.59 4.59 0 0 0 0 4.07l1.48-1.17a2.79 2.79 0 0 1-.14-.86Z"
    />
    <path
      fill="#E94235"
      d="M10.88 10.27c.66 0 1.24.23 1.7.68l1.27-1.3a4.22 4.22 0 0 0-2.97-1.18 4.44 4.44 0 0 0-3.97 2.5l1.48 1.17a2.66 2.66 0 0 1 2.5-1.87Z"
    />
  </svg>
);

export const AdyenDebitCard = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="26"
    fill="none"
    viewBox="0 0 40 26"
  >
    <path fill="#fff" d="M0 0h40v26H0z" />
    <path
      fill="#00112C"
      fillRule="evenodd"
      d="M30.1 21H9.9C8.84 21 8 20.17 8 19.15V6.85C8 5.83 8.85 5 9.9 5h20.2c1.05 0 1.9.83 1.9 1.85v12.3c0 1.02-.85 1.85-1.9 1.85z"
      clipRule="evenodd"
    />
    <rect width="5" height="2" x="25" y="17" fill="#fff" rx=".5" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M8 12h24V9H8v3z"
      clipRule="evenodd"
    />
  </svg>
);

export const AdyenPayPal = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 26">
    <path fill="#fff" d="M0 0h40v26H0z" />
    <path fill="#fff" d="M0 0h40v26H0z" />
    <path
      fill="#003086"
      d="M25.36 5.36c-.84-.95-2.34-1.35-4.27-1.35H15.5a.8.8 0 0 0-.79.67L12.4 19.44a.48.48 0 0 0 .47.56h3.45l.87-5.5-.03.17a.8.8 0 0 1 .79-.67h1.64c3.22 0 5.74-1.31 6.48-5.1l.05-.32a3.57 3.57 0 0 0-.75-3.22"
    />
    <path
      fill="#003086"
      d="M25.36 5.36c-.84-.95-2.34-1.35-4.27-1.35H15.5a.8.8 0 0 0-.79.67L12.4 19.44a.48.48 0 0 0 .47.56h3.45l.87-5.5-.03.17a.8.8 0 0 1 .79-.67h1.64c3.22 0 5.74-1.31 6.48-5.1l.05-.32a3.57 3.57 0 0 0-.75-3.22"
    />
    <path
      fill="#002f85"
      d="M18.1 8.6a.7.7 0 0 1 .7-.6h4.38a9.15 9.15 0 0 1 1.45.11l.37.07.34.09.17.05a3.96 3.96 0 0 1 .6.26 3.57 3.57 0 0 0-.75-3.22c-.84-.95-2.34-1.35-4.27-1.35H15.5a.8.8 0 0 0-.79.67L12.4 19.44a.48.48 0 0 0 .47.56h3.45l.87-5.5.93-5.9z"
    />
    <path
      fill="#009bdd"
      d="m26.11 8.58-.05.32c-.74 3.79-3.26 5.1-6.48 5.1h-1.64a.8.8 0 0 0-.79.67L16.31 20l-.24 1.5a.42.42 0 0 0 .42.5h2.9a.7.7 0 0 0 .7-.6l.02-.15.55-3.47.04-.2a.7.7 0 0 1 .69-.58h.43c2.82 0 5.03-1.15 5.67-4.46a3.8 3.8 0 0 0-.58-3.35 2.78 2.78 0 0 0-.8-.61"
    />
    <path
      fill="#012069"
      d="M25.34 8.27 25 8.18a6.55 6.55 0 0 0-.37-.07 9.1 9.1 0 0 0-1.45-.1H18.8a.7.7 0 0 0-.7.59l-.92 5.9-.03.17a.8.8 0 0 1 .79-.67h1.64c3.22 0 5.74-1.31 6.48-5.1l.05-.32a3.98 3.98 0 0 0-.6-.26z"
    />
  </svg>
);

export const AdyenApplePay = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="26"
    fill="none"
    viewBox="0 0 40 26"
  >
    <path
      fill="#000"
      d="M36.42 0H3.58a69.25 69.25 0 0 0-.75 0c-.25.01-.5.03-.76.07a2.51 2.51 0 0 0-1.32.7A2.43 2.43 0 0 0 .07 2.1 5.14 5.14 0 0 0 0 3.22v19.91c.01.25.03.51.07.76a2.6 2.6 0 0 0 .68 1.35 2.39 2.39 0 0 0 1.32.69 4.98 4.98 0 0 0 1.1.07h34a5 5 0 0 0 .76-.07 2.5 2.5 0 0 0 1.32-.7 2.44 2.44 0 0 0 .68-1.34 5.13 5.13 0 0 0 .07-1.11V2.87a6.5 6.5 0 0 0-.07-.76 2.58 2.58 0 0 0-.68-1.35 2.4 2.4 0 0 0-1.32-.69 4.96 4.96 0 0 0-1.1-.07h-.41Z"
    />
    <path
      fill="#fff"
      d="M36.42.87h.73c.2 0 .42.02.62.06a1.67 1.67 0 0 1 .88.44 1.58 1.58 0 0 1 .44.89 4.38 4.38 0 0 1 .06.97v19.55a14.67 14.67 0 0 1-.06.96 1.7 1.7 0 0 1-.44.89 1.54 1.54 0 0 1-.87.44 4.27 4.27 0 0 1-.96.06H2.85a3.7 3.7 0 0 1-.63-.06 1.66 1.66 0 0 1-.87-.45 1.56 1.56 0 0 1-.44-.88 4.35 4.35 0 0 1-.06-.97V2.9c.01-.2.02-.42.06-.63.03-.18.08-.34.16-.49A1.56 1.56 0 0 1 2.22.93a4.2 4.2 0 0 1 .96-.06h33.24"
    />
    <path
      fill="#000"
      d="M10.92 8.61c.34-.43.57-1 .51-1.59a2.21 2.21 0 0 0-1.99 2.3c.56.04 1.12-.3 1.48-.7Zm.51.81c-.82-.05-1.52.46-1.9.46-.4 0-1-.43-1.64-.42-.84 0-1.62.48-2.05 1.24-.88 1.52-.23 3.76.62 5 .42.6.92 1.27 1.58 1.25.62-.02.86-.4 1.62-.4.75 0 .97.4 1.63.39.69-.01 1.11-.61 1.53-1.22.47-.7.67-1.37.68-1.4-.01-.02-1.32-.52-1.33-2.02-.01-1.26 1.03-1.85 1.07-1.9a2.34 2.34 0 0 0-1.81-.98Zm7.11-1.7a2.87 2.87 0 0 1 3.02 3c0 1.8-1.27 3.03-3.06 3.03h-1.97v3.12h-1.42V7.72h3.43Zm-2 4.83h1.62c1.24 0 1.94-.66 1.94-1.82 0-1.15-.7-1.81-1.93-1.81h-1.64v3.63Zm5.39 2.43c0-1.17.9-1.89 2.48-1.98l1.83-.1v-.52c0-.74-.5-1.18-1.34-1.18-.8 0-1.3.38-1.41.97h-1.3c.08-1.2 1.1-2.09 2.76-2.09 1.62 0 2.65.86 2.65 2.2v4.6h-1.31v-1.1h-.04a2.38 2.38 0 0 1-2.1 1.2c-1.3 0-2.22-.8-2.22-2Zm4.3-.6v-.53l-1.64.1c-.82.06-1.28.42-1.28.99 0 .58.48.96 1.22.96.96 0 1.7-.66 1.7-1.52Zm2.61 4.95v-1.11c.1.03.33.03.44.03.64 0 .98-.27 1.19-.96l.12-.4-2.41-6.69h1.48l1.7 5.43h.02l1.69-5.43h1.44l-2.5 7.02c-.57 1.62-1.23 2.14-2.61 2.14a5.3 5.3 0 0 1-.56-.03Z"
    />
  </svg>
);
